import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/take';

import { SkyLinkRecordsState, SkyLinkRecordsStateDispatcher } from './state';
import { SkyLinkRecordsSelectedSetSelectedAction } from './state/selected/actions';
import { SkyLinkRecordsFieldModel } from './state/fields/field.model';
import { SkyLinkRecordsMatchModel } from './state/matches/match.model';
import { SKY_LINK_RECORDS_STATUSES } from './link-records-statuses';


export class SkyLinkRecordsItemDiffComponent implements OnInit {
  public STATUSES = SKY_LINK_RECORDS_STATUSES;
   public readOnly: boolean = false;
   public key: string;
   public item: any;
   public match: SkyLinkRecordsMatchModel;
   public fields: Array<any>;
   public selectedByDefault: boolean;
   public showNewFieldValues: boolean;

  /* istanbul ignore next */
  constructor(
    private state: SkyLinkRecordsState,
    private dispatcher: SkyLinkRecordsStateDispatcher
  ) { }

  public ngOnInit() {
    if (this.key === undefined) {
      throw new Error("'key' is required.");
    }
  }

  public setFieldSelected(fieldKey: string, ev: any) {
    this.dispatcher.next(
      new SkyLinkRecordsSelectedSetSelectedAction(this.key, fieldKey, ev.checked));
  }

  public trackByFieldKey(index: number, field: SkyLinkRecordsFieldModel) {
    return field.key;
  }

  get fieldValues() {
    return Observable.combineLatest(
      this.state.map((s: any) => s.fields.item[this.key] || []).distinctUntilChanged(),
      this.state.map((s: any) => s.selected.item[this.key] || {}).distinctUntilChanged(),
      (fields: SkyLinkRecordsFieldModel[], selected: { [key: string]: boolean }) => {
        return fields.map(f => {
          let checkCurrentValue: boolean = this.showNewFieldValues ? true : f.currentValue;

          return {
            field: checkCurrentValue && f.newValue &&
              f.newValue.toString().trim().length > 0 ? f : undefined,
            selected: selected[f.key] || false
          };
        });
      });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-link-records-item-diff',
  template: `<table>
  <thead>
    <tr *ngIf="readOnly">
      <th>{{'link_records_item_diff_header_field' | skyResources}}</th>
      <th>{{'link_records_item_diff_header_current_value' | skyResources}}</th>
    </tr>
    <tr *ngIf="!readOnly">
      <th>{{'link_records_item_diff_header_new_value' | skyResources}}</th>
      <th class="link-records-item-diff-update">{{'link_records_item_diff_header_update' | skyResources}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let fieldValue of fieldValues | async; trackBy: trackByFieldKey" [attr.cmp-id]="fieldValue.field?.key">
      <td *ngIf="readOnly && fieldValue.field">{{ fieldValue.field.label }}</td>
      <td *ngIf="readOnly && fieldValue.field" class="link-records-item-diff-value" [class.item-deemphasized]="fieldValue.selected" [class.item-highlighted]="!fieldValue.selected">{{ fieldValue.field.currentValue || ('link_records_item_diff_content_no_value' | skyResources) }}</td>
      <td *ngIf="!readOnly && fieldValue.field" class="link-records-item-diff-value" [class.item-deemphasized]="!fieldValue.selected" [class.item-highlighted]="fieldValue.selected">{{ fieldValue.field.newValue }}</td>
      <td *ngIf="!readOnly && fieldValue.field" class="link-records-item-diff-update">
        <sky-checkbox [checked]="fieldValue.selected" (change)="setFieldSelected(fieldValue.field.key, $event)"></sky-checkbox>
      </td>
    </tr>
  </tbody>
</table>
`,
  styles: [`:host {
  display: block;
  width: 100%;
}

:host table {
  border-collapse: collapse;
  width: 100%;
}

:host table th {
  font-family: "Blackbaud Sans", "Helvetica Neue", Arial, sans-serif;
  color: #686c73;
  font-weight: 400;
  font-size: 15px;
}

:host table th,
:host table td {
  padding: 10px 10px 10px 0;
  text-align: left;
}

:host table th.link-records-item-diff-update,
:host table td.link-records-item-diff-update {
  word-break: normal;
  text-align: center;
  width: 50px;
}

:host table th.link-records-item-diff-value,
:host table td.link-records-item-diff-value {
  word-break: break-all;
  white-space: pre-line;
}

:host table th.item-deemphasized,
:host table td.item-deemphasized {
  font-family: "Blackbaud Sans", "Helvetica Neue", Arial, sans-serif;
  color: #686c73;
  font-weight: 400;
  font-size: 15px;
  font-style: italic;
}

:host table th.item-highlighted,
:host table td.item-highlighted {
  font-weight: 600;
}

:host table tbody tr {
  border-bottom: 1px dotted #cdcfd2;
}

:host table tbody tr:first-child {
  border-top: 1px dotted #cdcfd2;
}

:host /deep/ sky-checkbox .sky-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}
`],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyLinkRecordsState, },
{type: SkyLinkRecordsStateDispatcher, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'readOnly': [{ type: Input },],
'key': [{ type: Input },],
'item': [{ type: Input },],
'match': [{ type: Input },],
'fields': [{ type: Input },],
'selectedByDefault': [{ type: Input },],
'showNewFieldValues': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
